
















































































import Vue from 'vue'

const dialToRadian = (dialIndex: number) => ((3 - dialIndex) / 6) * Math.PI
const PI2 = Math.PI * 2

export default Vue.extend({
  data() {
    return {
      radius: 200,
      dialNumbers: [...new Array(12)].map((_, i) => ((i + 11) % 12) + 1),
      now: new Date(),
    }
  },
  computed: {
    hourVal(): number {
      return this.now.getHours() + this.minVal / 60
    },
    minVal(): number {
      return this.now.getMinutes() + this.secVal / 60
    },
    secVal(): number {
      return this.now.getSeconds() + this.now.getMilliseconds() / 1000
    },
    diameter(): number {
      return this.radius * 2
    },
    hourStyle(): Record<string, string> {
      const rad = ((3 - this.hourVal) / 12) * PI2
      return {
        transform: `rotate(${rad * -1}rad)`,
      }
    },
    minStyle(): Record<string, string> {
      const rad = ((15 - this.minVal) / 60) * PI2
      return {
        transform: `rotate(${rad * -1}rad)`,
      }
    },
    secStyle(): Record<string, string> {
      const rad = ((15 - this.secVal) / 60) * PI2
      return {
        transform: `rotate(${rad * -1}rad)`,
      }
    },
  },
  mounted() {
    this.update()
  },
  methods: {
    getTextStyle(i: number) {
      const x = Math.cos(dialToRadian(i)) * this.radius * 0.85
      const y = -Math.sin(dialToRadian(i)) * this.radius * 0.85
      return {
        left: `${x}px`,
        top: `${y}px`,
        fontSize: `${this.radius * 0.15}px`,
        // transform: `translate(${x}px, ${y}px)`,
      }
    },
    getDialX(i: number) {
      return Math.cos(dialToRadian(i)) * this.radius * 0.9
    },
    getDialY(i: number) {
      return -Math.sin(dialToRadian(i)) * this.radius * 0.9
    },
    update() {
      this.now = new Date()
      requestAnimationFrame(this.update)
    },
  },
})
